export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7818.8560d3ed.jpg";